"use client";

import { useTranslation } from "@/i18n/client";
import color from "@/styles/color";
import { Box, Stack, Typography } from "@mui/material";
import NextDynamic from "next/dynamic";
import { DividerCustom } from "@/components/Divider/DividerCustom";


import WantToBuySearchInput from "./components/WantToBuySearchInput";

const WantToBuyFilter = NextDynamic(() => import("./WantToBuyFilter"), {
  ssr: true,
});

const WantToBuySideBar = () => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: { xs: "none", lg: "block" },
        background: color.white,
        borderRadius: "16px",
        boxShadow: "0px 4px 4px 0px #0000001A",
        padding: "16px 24px",
        height: "fit-content",
        width: "441px",
      }}
    >
      <Stack sx={{ gap: 2 }}>
        <Typography
          sx={{
            fontWeight: 700,
            color: color.black,
            fontSize: "1.25rem",
            lineHeight: "1.875rem",
            textAlign: { xs: "center" },
          }}
        >
          {t("W2B.filter.title")}
        </Typography>
        <WantToBuySearchInput />
        <DividerCustom
          sx={{
            display: { xs: "none", xl: "inherit" },
            "&.MuiDivider-root": {
              margin: "0px",
              borderColor: color.gray600,
            },
          }}
        />
        <WantToBuyFilter />
      </Stack>
    </Box>
  );
};

export default WantToBuySideBar;
